/**
 * localStorage that degrades instead of throwing.
 *
 * On iOS Safari with "Block All Cookies" (and inside some restricted WebView
 * contexts) every `localStorage` access throws SecurityError / DOMException
 * 18 — including `removeItem`. That is how `/home` went blank for those
 * users: the home cache's own catch block called `clearCache()`, whose
 * unguarded `removeItem` threw a SECOND time, out of the catch, during
 * render, with no ErrorBoundary above it (ORDER-THISWAY-24).
 *
 * Same idiom as `chunkReloadGuard.js`'s sessionStorage wrappers: never
 * throw, just behave as if storage held nothing.
 */

export function safeGetItem(key) {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function safeSetItem(key, value) {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

export function safeRemoveItem(key) {
  try {
    localStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}
